const Neutral = {
  neutral: {
    main: '#3B485D',
    light: '#FFFFFF',
    dark: '#0C192F',
    '10': '#0C192F',
    '20': '#2C384B',
    '30': '#3B485D',
    '40': '#536077',
    '50': '#616C82',
    '55': '#6D778A',
    '60': '#A1A8B4',
    '65': '#B6BBC6',
    '70': '#C5C9D3',
    '75': '#D0D4DC',
    '80': '#DCDFE4',
    '85': '#E9EBEE',
    '90': '#F3F4F6',
    '95': '#F9F9FB',
    '100': '#FFFFFF',
  },
};

export default Neutral;
